import { getBrowserClient } from '@/lib/integrations/supabase/client';
import type { StaffMember, StaffMemberWithProfile } from '@/lib/integrations/supabase/types';

export async function getStaffMembers(businessId: string): Promise<StaffMemberWithProfile[]> {
  const supabase = getBrowserClient();

  const { data, error } = await supabase
    .from('staff_members')
    .select(`
      *,
      profile:profiles(*)
    `)
    .eq('business_id', businessId)
    .eq('active', true)
    .order('display_name', { ascending: true });

  if (error) {
    throw error;
  }

  const filtered = (data || []).filter((staff: StaffMemberWithProfile) =>
    staff.profile?.role !== 'owner' && staff.profile?.role !== 'admin'
  );

  return filtered as StaffMemberWithProfile[];
}

export async function getAllStaffMembers(businessId: string): Promise<StaffMemberWithProfile[]> {
  const supabase = getBrowserClient();

  const { data, error } = await supabase
    .from('staff_members')
    .select(`
      *,
      profile:profiles(*)
    `)
    .eq('business_id', businessId)
    .order('display_name', { ascending: true });

  if (error) {
    throw error;
  }

  return (data || []) as StaffMemberWithProfile[];
}

export async function getStaffMember(id: string): Promise<StaffMemberWithProfile | null> {
  const supabase = getBrowserClient();

  const { data, error } = await supabase
    .from('staff_members')
    .select(`
      *,
      profile:profiles(*)
    `)
    .eq('id', id)
    .single();

  if (error) {
    if (error.code === 'PGRST116') return null;
    throw error;
  }

  return data as StaffMemberWithProfile;
}

export async function getCurrentUserStaffMember(
  businessId: string,
  userId: string
): Promise<StaffMember | null> {
  const supabase = getBrowserClient();

  const { data, error } = await supabase
    .from('staff_members')
    .select('*')
    .eq('business_id', businessId)
    .eq('profile_id', userId)
    .single();

  if (error) {
    if (error.code === 'PGRST116') {
      return null;
    }
    throw error;
  }

  return data;
}
